<template>
  <Common>
    <template #transport>
      <h2>{{$t('track.trackWay.mongolia.h2')}}</h2>
      <p>{{$t('track.trackWay.mongolia.p1')}}</p>
      <p>{{$t('track.trackWay.mongolia.p2')}}</p>
      <p>{{$t('track.trackWay.mongolia.p3')}}</p>
      <p>{{$t('track.trackWay.mongolia.p4')}}</p>
    </template>

    <!-- <template #pay>
      <h3>{{$t('track.trackWay.mongolia.pay.h3')}}</h3>
      <p>
        {{$t('track.trackWay.mongolia.pay.p1')}}<br />
        {{$t('track.trackWay.mongolia.pay.p2')}}
      </p>
    </template> -->
  </Common>
</template>

<script>
import Common from "@/views/track/components/Common";
export default {
  components: { Common },
};
</script>

<style>
</style>